export const assetsConstants = {
  ASSETS_HAS_ERRORED: "ASSETS_HAS_ERRORED",
  ASSETS_IS_LOADING: "ASSETS_IS_LOADING",
  ASSETS_FETCH_DATA_SUCCESS: "ASSETS_FETCH_DATA_SUCCESS",
};
